import { ageLabel, formatAbsoluteDate } from '../../../../utils/relative-age';

import { QrStat } from './QrStat';

export interface QrStats {
  total: number;
  last30: number;
  /** When the code was last scanned, or null if it never was. */
  lastScanAt: string | null;
}

const NOT_TRACKED = 'not tracked yet';

function lastScanNote(stats: QrStats | null): string {
  if (!stats) return NOT_TRACKED;
  return stats.lastScanAt ? formatAbsoluteDate(stats.lastScanAt) : 'never scanned';
}

function last30Note(stats: QrStats | null): string {
  if (!stats) return NOT_TRACKED;
  return stats.last30 === 0 ? 'no recent scans' : 'scans';
}

/** Total, last 30 days and last scan. "—" when there are no figures. */
export function QrScanStats({ stats }: { stats: QrStats | null }) {
  const lastScan = stats?.lastScanAt;
  return (
    <div style={{ display: 'grid', gridTemplateColumns: 'repeat(3, minmax(0,1fr))', gap: 12 }}>
      <QrStat
        label="Total scans"
        value={stats ? stats.total.toLocaleString() : '—'}
        note={stats ? 'all time' : NOT_TRACKED}
      />
      <QrStat
        label="Last 30 days"
        value={stats ? stats.last30.toLocaleString() : '—'}
        note={last30Note(stats)}
      />
      <QrStat
        label="Last scan"
        value={lastScan ? ageLabel(lastScan) : '—'}
        note={lastScanNote(stats)}
      />
    </div>
  );
}
